import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'

import home from './views/home.vue'
import topic from './views/topic.vue'
import means from './views/means.vue'
import mean from './views/mean.vue'
import examples from './views/examples.vue'
import example from './views/example.vue'
import manage from './views/manage.vue'

Vue.use(Router)

// router / routes
const router = new Router({
  mode: 'history',
  base: './',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/aiheet/:topic_id',
      name: 'aihe',
      component: topic
    },
    {
      path: '/keinot',
      name: 'keinot',
      component: means,
      props: true // oliko tälle ennää käyttöä?
      /* children: [
        { path: ':mean_id', name: 'mean', component: mean }
      ] */
    },
    {
      path: '/keinot/:mean_id',
      name: 'keino',
      component: mean
    },
    {
      path: '/kohteet',
      name: 'kohteet',
      component: examples
      /* children: [
        { path: '/kohteet/:example_id', name: 'example', component: example }
      ] */
    },
    {
      path: '/kohteet/:example_id',
      name: 'kohde',
      component: example
    },
    {
      path: '/hallinnointi',
      name: 'manage',
      component: manage,
      meta: {
        requireAuth: true // for route guard
      }
    },
    /* all other paths / catch-all */
    { path: '*', redirect: '/' }
  ]
})

// route guards
router.beforeEach((to, from, next) => {
  let logged = () => {
    if (this.$store.state.isLogged || this.$cookie.get('isLogged')) {
      return true
    }
  }
  // check to see if route requires auth
  if (to.matched.some(rec => { return rec.meta.requireAuth })) {
    // check isLogged state
    if (logged) {
      // user logged in, proceed to route
      next()
    } else {
      // user not logged in, redirect to homepage
      alert('Kirjautuminen vaadittu!')
      next({ name: 'home' })
    }
  } else {
    next()
  }
})

export default router
